// extracted by mini-css-extract-plugin
module.exports = {"root":"LegendList_root_6gwyd","item":"LegendList_item_3rDs8","description":"LegendList_description_Pulgx"};